import { Button } from '@ordr-as/umami-react/button';
import { FC } from 'react';
import useIntl from '../hooks/useIntl';

interface Props {
  navigateTo: VoidFunction;
  text?: string;
  className?: string;
  title?: string;
}

const CloseButton: FC<Props> = ({ navigateTo, text, className, title }) => {
  const intl = useIntl();
  return (
    <Button onClick={navigateTo} className={`p-4 w-full border-b bg-brand-white border-grey-medium flex ${className}`}>
      <div className="flex items-center flex-1">
        <span className="pl-1 text-grey-dark text-small">{text || intl.formatMessage({ id: 'generic.close' })}</span>
      </div>
      {title && <h4 className="">{title}</h4>}
      <div className="flex-1" />
    </Button>
  );
};

export default CloseButton;
